module.exports = __webpack_public_path__ + "img/Mask.0a44b790.svg";